import React, { useState, useRef, useEffect } from "react";
import { Container, Button, Modal, Form } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import { QrReader } from "react-qr-reader";
import jsQR from "jsqr";

const QRCodeHandler = ({ shoppingList, addItemsFromQR }) => {
    const [showQR, setShowQR] = useState(false);
    const [showScanner, setShowScanner] = useState(false);
    const [showFileUpload, setShowFileUpload] = useState(false);
    const [cameraActive, setCameraActive] = useState(false);
    const qrRef = useRef(null);

    // 🔵 **Vygenerujeme QR kód z nákupního seznamu**
    const generateQRCodeData = () => JSON.stringify(shoppingList);

    // 🟢 **Uložíme QR kód jako obrázek**
    const saveQRCode = () => {
        const canvas = qrRef.current.querySelector("canvas");
        const imgData = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = imgData;
        link.download = "shopping_list_qr.png";
        link.click();
    };

    // ✅ **Zapneme kameru při otevření modalu**
    useEffect(() => {
        setCameraActive(showScanner);
    }, [showScanner]);

    // 🔴 **Zpracujeme naskenovaný QR kód (kamera)**
    const handleScan = (result, error) => {
        if (result) {
            try {
                const parsedData = JSON.parse(result.text);
                addItemsFromQR(parsedData);
                alert("✅ QR kód úspěšně načten!");
                setShowScanner(false);
            } catch (error) {
                alert("⚠️ Neplatný QR kód!");
            }
        }
        if (error) console.error(error);
    };

    // 📂 **Zpracujeme QR kód z obrázku**
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);
                const imageData = ctx.getImageData(0, 0, img.width, img.height);
                const qrCode = jsQR(imageData.data, imageData.width, imageData.height);
                if (qrCode) {
                    try {
                        const parsedData = JSON.parse(qrCode.data);
                        addItemsFromQR(parsedData);
                        alert("✅ QR kód úspěšně naskenován!");
                        setShowFileUpload(false);
                    } catch (error) {
                        alert("⚠️ Neplatný QR kód!");
                    }
                } else {
                    alert("⚠️ QR kód nebyl nalezen!");
                }
            };
        };
        reader.readAsDataURL(file);
    };

    return (
        <Container className="text-center">
            {/* 🔹 Generování QR */}
            <Button variant="primary" className="m-2" onClick={() => setShowQR(true)}>
                📷 Generovat QR
            </Button>

            {/* 🔹 Skenování QR kamerou */}
            <Button variant="secondary" className="m-2" onClick={() => setShowScanner(true)}>
                📡 Naskenovat QR (kamera)
            </Button>

            {/* 🔹 Nahrání QR souboru */}
            <Button variant="warning" className="m-2" onClick={() => setShowFileUpload(true)}>
                📂 Nahrát QR kód
            </Button>

            {/* 🔹 MODÁL GENEROVÁNÍ QR */}
            <Modal show={showQR} onHide={() => setShowQR(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>📷 QR kód nákupního seznamu</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div ref={qrRef}>
                        <QRCodeCanvas value={generateQRCodeData()} size={256} />
                    </div>
                    <Button variant="success" className="mt-3" onClick={saveQRCode}>
                        💾 Uložit QR
                    </Button>
                </Modal.Body>
            </Modal>

            {/* 🔹 MODÁL SKENOVÁNÍ QR (KAMERA) */}
            <Modal show={showScanner} onHide={() => setShowScanner(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>📡 Naskenovat QR (kamera)</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {cameraActive && (
                        <QrReader
                            constraints={{ facingMode: "environment" }} // ✅ Používá zadní kameru
                            scanDelay={500} // 📡 Skenuje každých 500ms
                            onResult={handleScan}
                            containerStyle={{ width: "100%" }}
                            videoContainerStyle={{ width: "100%", height: "auto" }}
                            videoStyle={{ width: "100%", height: "auto", borderRadius: "10px" }}
                        />
                    )}
                </Modal.Body>
            </Modal>

            {/* 🔹 MODÁL NAHRÁNÍ QR SOUBORU */}
            <Modal show={showFileUpload} onHide={() => setShowFileUpload(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>📂 Nahrát QR kód</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <Form.Group>
                        <Form.Control type="file" accept="image/*" onChange={handleFileUpload} />
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default QRCodeHandler;
